module.exports = __webpack_public_path__ + "static/media/slide1.568f45e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slide1.jpg
// module id = 5861
// module chunks = 0